import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonMultiFileUploadServiceSub } from 'src/app/commons/kymw00/pless-json-multi-file-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { RegistCwsIconDataVo } from '../vo/regist-cws-icon-data.model'

/**
 * アイコン情報登録
 *
 * @export
 * @class RegistCwsIconData
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCwsIconData extends PlessJsonMultiFileUploadServiceSub<any> {
  private vo: RegistCwsIconDataVo;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCwsIconData
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.iconCode,
        IconName: this.vo.iconName,
        GroupCode: this.vo.groupCode,
        IconDiv: this.vo.iconDiv,
        ArrangeDiv: this.vo.arrangeDiv,
        IconExplain: this.vo.iconExplain,
        OutputDiv: this.vo.outputDiv,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        IconAlternativeText: this.vo.iconAlternativeText
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof RegistCwsIconData
   */
  execute(vo: RegistCwsIconDataVo, fileList: File[], successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.sendFile('registCwsIconData', this.getBody(), fileList);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistCwsIconFileData
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
